// extracted by mini-css-extract-plugin
module.exports = {"root":"Toolbar_root__2H31N","lightBg":"Toolbar_lightBg__2w7r0","darkBg":"Toolbar_darkBg__3DPao"};